import React from 'react';
import { Box, Container } from '@mui/material';
import { ConfigWizard } from '../components/ConfigWizard';

export const WhatsAppSetup: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <ConfigWizard />
      </Box>
    </Container>
  );
};
